import { Link } from "react-router-dom";
import { InstagramLogo, TiktokLogo, PinterestLogo } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-[#FAF8F5] mt-32" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif text-4xl lg:text-5xl mb-6">Come back to touch.</div>
          <p className="text-[#D9C5B2] max-w-md leading-relaxed mb-8">Iamravishing is a house for couples returning to closeness — and for the woman dressing first for herself. Join The Boudoir for early access, private events, and 15% off your first order.</p>
          <form className="flex gap-2 max-w-md" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="Your email" className="flex-1 bg-transparent border-b border-[#D9C5B2] px-0 py-3 focus:outline-none focus:border-[#FAF8F5] text-[#FAF8F5] placeholder:text-[#5C5C5C]" data-testid="newsletter-email" />
            <button type="submit" className="overline border-b border-[#D9C5B2] pb-3 text-[#FAF8F5] hover:border-[#FAF8F5]" data-testid="newsletter-submit">Subscribe</button>
          </form>
        </div>

        <div className="md:col-span-2">
          <div className="overline text-[#D9C5B2] mb-5">Shop</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop?category=bras" className="hover:text-[#D9C5B2]" data-testid="footer-bras">Bras</Link></li>
            <li><Link to="/shop?category=panties" className="hover:text-[#D9C5B2]" data-testid="footer-panties">Panties</Link></li>
            <li><Link to="/shop?category=sets" className="hover:text-[#D9C5B2]" data-testid="footer-sets">Sets</Link></li>
            <li><Link to="/shop?category=sleepwear" className="hover:text-[#D9C5B2]" data-testid="footer-sleepwear">Sleepwear</Link></li>
            <li><Link to="/shop?category=bodysuits" className="hover:text-[#D9C5B2]" data-testid="footer-bodysuits">Bodysuits</Link></li>
            <li><Link to="/reconnect" className="hover:text-[#D9C5B2]" data-testid="footer-wellness">Reconnect</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline text-[#D9C5B2] mb-5">House</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/lookbook" className="hover:text-[#D9C5B2]" data-testid="footer-lookbook">Lookbook</Link></li>
            <li><Link to="/about" className="hover:text-[#D9C5B2]" data-testid="footer-about">Our Story</Link></li>
            <li><Link to="/shipping-returns#fit-guide" className="hover:text-[#D9C5B2]" data-testid="footer-fit">Fit Guide</Link></li>
            <li><Link to="/journal" className="hover:text-[#D9C5B2]" data-testid="footer-journal">Journal</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[#D9C5B2] mb-5">Care</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shipping-returns" className="hover:text-[#D9C5B2]" data-testid="footer-shipping">Shipping & Returns</Link></li>
            <li><Link to="/contact" className="hover:text-[#D9C5B2]" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-[#D9C5B2]" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-[#D9C5B2]" data-testid="footer-privacy">Privacy</Link></li>
          </ul>
          <div className="flex gap-4 mt-8">
            <a href="#" data-testid="social-instagram"><InstagramLogo size={22} weight="light" /></a>
            <a href="#" data-testid="social-tiktok"><TiktokLogo size={22} weight="light" /></a>
            <a href="#" data-testid="social-pinterest"><PinterestLogo size={22} weight="light" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#5C5C5C]/30 py-6 text-center text-xs text-[#5C5C5C]">
        © 2026 Iamravishing. Made with intention.
      </div>
    </footer>
  );
}
